export default __webpack_public_path__ + "static/media/host_groupTalk.437f13e7.svg";